class ShopTheLook extends HTMLElement {
  constructor() {
    super();
    this._onHotspotClick = this._onHotspotClick.bind(this);
    this._onBlockSelect = this._onBlockSelect.bind(this);
  }

  connectedCallback() {
    this.sectionEl = this.closest('.shopify-section');
    this.hotspots = this.querySelectorAll('[data-stl-hotspot]');
    this.panels = this.querySelectorAll('[data-stl-panel]');

    this.hotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', this._onHotspotClick);
    });

    document.addEventListener('shopify:block:select', this._onBlockSelect);

    const active = this.querySelector('[data-stl-hotspot].is-active');
    if (active) {
      this.selectHotspot(active.dataset.stlHotspot, false);
      return;
    }

    const firstWithPanel = Array.from(this.hotspots).find((hotspot) => this.findPanel(hotspot.dataset.stlHotspot));
    if (firstWithPanel) {
      this.selectHotspot(firstWithPanel.dataset.stlHotspot, false);
    } else if (this.hotspots.length) {
      this.selectHotspot(this.hotspots[0].dataset.stlHotspot, false);
    }
  }

  disconnectedCallback() {
    this.hotspots.forEach((hotspot) => {
      hotspot.removeEventListener('click', this._onHotspotClick);
    });
    document.removeEventListener('shopify:block:select', this._onBlockSelect);
  }

  _onBlockSelect(event) {
    if (!this.sectionEl || event.target !== this.sectionEl) return;

    const blockId = event.detail && event.detail.blockId;
    if (blockId && this.querySelector(`[data-stl-hotspot="${blockId}"]`)) {
      this.selectHotspot(blockId, false);
    }
  }

  _onHotspotClick(event) {
    const hotspot = event.currentTarget;
    this.selectHotspot(hotspot.dataset.stlHotspot, true);
  }

  selectHotspot(id, focusPanel) {
    if (!id) return;

    const panel = this.findPanel(id);

    this.hotspots.forEach((hotspot) => {
      const isActive = hotspot.dataset.stlHotspot === id;
      hotspot.classList.toggle('is-active', isActive);
      hotspot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (panel) {
      this.panels.forEach((item) => {
        item.classList.toggle('is-hidden', item.dataset.stlPanel !== id);
      });
    }

    if (focusPanel && panel) {
      const link = panel.querySelector('.shop-the-look__title-link, .shop-the-look__media-link');
      if (link) link.focus({ preventScroll: true });
    }
  }

  findPanel(id) {
    return Array.from(this.panels).find((panel) => panel.dataset.stlPanel === id);
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook);
}
